import { PAGE_PEOPLE_ACTION_SUBJECT } from '../analytics.ts';

// The Teamwork Graph surface these page-people operational events are emitted from.
const PAGE_PEOPLE_SOURCE = 'teamworkGraphPreviewPanel';

/** Category of a page-people fetch failure. */
export type PagePeopleErrorType = 'network' | 'graphql';

/**
 * Fired once per hook instance when the people query settles without error. `count` is the
 * ranked list, so at most `MAX_LISTED_PAGE_PEOPLE` — not however many a given surface goes on
 * to show. No name, account id or other person detail goes into the payload.
 */
export const getPagePeopleSucceededEvent = (attributes: {
	count: number;
}): {
	readonly type: 'sendOperationalEvent';
	readonly data: {
		readonly action: 'succeeded';
		readonly actionSubject: 'pagePeople';
		readonly source: 'teamworkGraphPreviewPanel';
		readonly attributes: { count: number };
	};
} =>
	({
		type: 'sendOperationalEvent',
		data: {
			action: 'succeeded',
			actionSubject: PAGE_PEOPLE_ACTION_SUBJECT,
			source: PAGE_PEOPLE_SOURCE,
			attributes,
		},
	}) as const;

/** Fired when the page-people graph query errors (network or GraphQL). */
export const getPagePeopleFailedEvent = (attributes: {
	errorType: PagePeopleErrorType;
}): {
	readonly type: 'sendOperationalEvent';
	readonly data: {
		readonly action: 'failed';
		readonly actionSubject: 'pagePeople';
		readonly source: 'teamworkGraphPreviewPanel';
		readonly attributes: { errorType: PagePeopleErrorType };
	};
} =>
	({
		type: 'sendOperationalEvent',
		data: {
			action: 'failed',
			actionSubject: PAGE_PEOPLE_ACTION_SUBJECT,
			source: PAGE_PEOPLE_SOURCE,
			attributes,
		},
	}) as const;
